"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var kb_tree_node_1 = require("./kb-tree-node");
var KbTreeModel = /** @class */ (function () {
    function KbTreeModel() {
        this.patronNodes = [];
    }
    KbTreeModel.prototype.createTreeFromGroups = function (groups, moduleRegistry) {
        var _this = this;
        groups.map(function (group) {
            var newGroupTreeNode = new kb_tree_node_1.KbTreeNode(group.getDisplayName(), group.getDisplayNameMultilingual());
            group.getMetaFields().map(function (metaField) {
                _this.addLeafNode(metaField, newGroupTreeNode, moduleRegistry);
            });
            _this.patronNodes.push(newGroupTreeNode);
        });
    };
    KbTreeModel.prototype.addLeafNode = function (metaField, newTreeNode, moduleRegistry) {
        if (metaField.getIsSystemField()) {
            return;
        }
        var metaControl$;
        if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE ||
            metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE) {
            metaControl$ = moduleRegistry.findControl('sis-date-picker');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
            if (metaField.getIsMultiline()) {
                metaControl$ = moduleRegistry.findControl('sis-multilingual-textarea');
            }
            else {
                metaControl$ = moduleRegistry.findControl('sis-multilingual-textbox');
            }
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
            metaControl$ = moduleRegistry.findControl('inline-sis-table');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER) {
            metaControl$ = moduleRegistry.findControl('sis-integer');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DECIMAL ||
            metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL) {
            metaControl$ = moduleRegistry.findControl('sis-decimal');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.BOOLEAN) {
            metaControl$ = moduleRegistry.findControl('sis-single-checkbox');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT) {
            metaControl$ = moduleRegistry.findControl('sis-dynamic-multiselect');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.USER) {
            metaControl$ = moduleRegistry.findControl('sis-user');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME) {
            metaControl$ = moduleRegistry.findControl('sis-date-time-picker');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DOCUMENT) {
            metaControl$ = moduleRegistry.findControl('sis-dynamic-document');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.STRING) {
            if (metaField.getIsMultiline()) {
                metaControl$ = moduleRegistry.findControl('sis-textarea');
            }
            else {
                metaControl$ = moduleRegistry.findControl('sis-textbox');
            }
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
            metaControl$ = moduleRegistry.findControl('sis-combo-box');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MONEY) {
            metaControl$ = moduleRegistry.findControl('sis-dynamic-money');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING) {
            metaControl$ = moduleRegistry.findControl('sis-dynamic-accounting');
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
            metaControl$ = moduleRegistry.findControl('sis-dynamic-entity-select');
        }
        if (metaControl$) {
            metaControl$
                .pipe(operators_1.first(), operators_1.tap(function (metaControl) {
                return newTreeNode.addChildLeaf(metaControl, metaField);
            }))
                .subscribe(noop_1.noop, console.error);
        }
    };
    return KbTreeModel;
}());
exports.KbTreeModel = KbTreeModel;
//# sourceMappingURL=kb-tree.model.js.map